import {
  CONTACT_BLOCK_MESSAGE,
  GENERAL_VIOLATION_MESSAGE,
} from "./contact-policy"

export type ViolationType = "contact" | "illegal" | "general"

const CONTACT_REASON_HINTS = [
  "contact",
  "reach me",
  "email",
  "phone",
  "number",
  "handle",
  "instagram",
  "insta",
  "whatsapp",
  "telegram",
  "discord",
  "paypal",
  "venmo",
  "cashapp",
  "cash app",
  "zelle",
  "wire",
  "bank transfer",
  "payment details",
  "off-platform",
  "outside the platform",
] as const

export function getModerationDisplayMessage(raw?: string | null, matches?: string[] | null) {
  const normalized = `${raw ?? ""} ${(matches ?? []).join(" ")}`.toLowerCase()
  const matchesContact = CONTACT_REASON_HINTS.some((hint) => normalized.includes(hint))
  if (matchesContact) {
    return { message: CONTACT_BLOCK_MESSAGE, type: "contact" as ViolationType }
  }
  return { message: GENERAL_VIOLATION_MESSAGE, type: "general" as ViolationType }
}

export const MODERATION_LEAD_DEFAULT =
  "Concealed within his fortress, the lord of Mordor sees all. His gaze pierces cloud, shadow, earth, and flesh.";
export const MODERATION_FOOTER_DEFAULT =
  "Before you proceed, take a moment to consult our Terms of Service (ToS).";

export function splitModerationMessage(raw?: string | null) {
  if (!raw) {
    return null;
  }
  const parts = raw
    .split(/\n\s*\n/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length === 0) {
    return null;
  }
  const [lead, reason, ...rest] = parts;
  return {
    lead,
    reason,
    footer: rest.length ? rest.join("\n\n") : undefined,
  };
}

export function getModerationReason(raw?: string | null) {
  const parsed = splitModerationMessage(raw);
  if (parsed?.reason) {
    return parsed.reason;
  }
  return raw ?? undefined;
}

